import { dataLayerTracking } from "@/libs/gtmTracking";

export const GAProductClickedEvent = (itemData) => {
  dataLayerTracking({
    event: "product_card_clicked",
    item_name: itemData.name,
    item_id: itemData.sku,
    ecommerce: {
      currency: "INR",
      items: [
        {
          item_brand: itemData?.brand || "",
          item_list_name: "",
          discounted_price: itemData.special_price || "",
          index: 1,
          discount: itemData?.special_price ? Number(itemData?.special_price) - itemData?.price : 0,
          item_name: itemData.name,
          item_id: itemData.sku,
          price: itemData.price,
          item_category: itemData?.classifier_1,
          item_category2: itemData?.classifier_2,
          item_category3: itemData?.classifier_3,
          item_category4: itemData?.is_in_stock ? "in stock" : "out of stock",
          item_category5: itemData?.type_id,
          item_variant: "Default",
          // location_id: sessionStorage?.getItem("location_id") || "",
        },
      ],
    },
  });
};
